import { http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';

export class LegalDocumentsTemplateService {
   async getLegalDocumentsTemplates(query?: LocationQuery) {
      const response = await http.get<string>(`/legal-documents-templates`, { params: { ...query } });
      return response.data;
   }

   async getLegalDocumentsTemplate() {
      throw Error('Method not implemented');
   }

   async postLegalDocumentsTemplate() {
      throw Error('Method not implemented');
   }

   async putLegalDocumentsTemplate() {
      throw Error('Method not implemented');
   }

   async deleteLegalDocumentsTemplate() {
      throw Error('Method not implemented');
   }
}
